import http from './http'

export default class schemeApi {
  static getOpenSchemes(endpoint) {
    return http.get(endpoint)
  }
}
